<div class="map-container" [ngClass]="styleClass">
  <div
    leaflet
    [leafletOptions]="options"
    [leafletLayers]="markerLayers"
    (leafletMapReady)="map = $event; fitBounds()"
    style="height: 100%; width: 100%"
  ></div>
</div>
